import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableC from '../../../basicElement/TableC';
import genOperationAuth from '../../../common/genOperationAuth';
import { Icon, Tooltip } from 'antd';

class Filter extends Component {
    static contextTypes = {
        curRole: PropTypes.string,
        roleAuth: PropTypes.bool,
        isConfig: PropTypes.bool,
        isCompleted: PropTypes.bool,
    }

    getColumns = () => {
        const { omit, update, relate, showHospital } = this.props;
        const { curRole, roleAuth, isConfig, isCompleted } = this.context;

        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: 'left',
            sorter: true,
            width: 90,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: 'left',
            width: 200,
        }, {
            title: '所属医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
            render: (text, record) => {
                const { hospitalMainId } = record;
                return <a onClick={() => showHospital(hospitalMainId)}>{text}</a>;
            },
        }, {
            title: '所属院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        },{
            title: '所属科室',
            dataIndex: 'hospitalDepartmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '研究中心项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
        }, {
            title: '中心合同计划单访视工时折算系数',
            dataIndex: 'visitHourConversionFactor',
            key: 'visitHourConversionFactor',
            width: 100,
        }, {
            title: '中心在项目内是否是组长单位',
            dataIndex: 'groupLeaderUnitStr',
            key: 'groupLeaderUnitStr',
            width: 180,
        }, {
            title: '启动前是否津石负责',
            dataIndex: 'groupManagerBeforeStart',
            key: 'groupManagerBeforeStart',
            width: 180,
            render: text => text ? '是' : '否'
        }, {
            title: '是否涉及中心调研',
            dataIndex: 'relatedSiteSurvey',
            key: 'relatedSiteSurvey',
            width: 180,
            render: text => text ? '是' : '否'
        }, {
            title: '申办方是否选中',
            dataIndex: 'sponsorSelected',
            key: 'sponsorSelected',
            width: 180,
            render: text => text == 1 ? '是' : text == -1 ? '待定' : text == 0 ? '否' : ''
        }, {
            title: <span>
                有无破盲风险
                <Tooltip overlayClassName="downloadSite" placement="top" title={<div>
                    <span style={{ color: '#dad20b' }}>破盲风险判断</span><br/>
                    1、医院有中心药房：CRC可以直接接触全部药物，确定有破盲风险；<br/>
                    2、医院有中心药房：CRC仅签字取药，医院主管自主判断是否有破盲风险；<br/>
                    3、医院有中心药房，科室也可存放药物：CRC可以直接接触全部药物，确定有破盲风险；<br/>
                    4、医院有中心药房，科室也可存放药物：CRC仅签字取药，医院主管自主判断是否有破盲风险；<br/>
                    5、医院有中心药房，科室也可存放药物：同科室有交叉项目，医院主管自主判断是否有破盲风险；<br/>
                    6、医院无中心药房，确认药物存放环境：CRC可以直接接触全部药物，确定有破盲风险；<br/>
                    7、医院无中心药房，确认药物存放环境：CRC仅签字取药，医院主管自主判断是否有破盲风险；<br/>
                    8、医院无中心药房，确认药物存放环境：同科室有交叉项目，医院主管自主判断是否有破盲风险；
                    </div>}>
                    <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                </Tooltip>
            </span>,
            dataIndex: 'unblindingRisk',
            key: 'unblindingRisk',
            width: 120,
            render: text => String(text) === 'true' ? '有' : (String(text) === 'false' ? '无' : '')
        }, {
            title: '破盲风险等级',
            dataIndex: 'unblindingRiskLevelShow',
            key: 'unblindingRiskLevelShow',
            width: 100,
        }, {
            title: '负责人',
            dataIndex: 'userName',
            key: 'userName',
            width: 100,
        }, {
            title: '职务',
            dataIndex: 'doctorPosition',
            key: 'doctorPosition',
            width: 100,
        }, {
            title: '手机号码',
            dataIndex: 'mobile',
            key: 'mobile',
            width: 100,
        }, {
            title: '固定电话',
            dataIndex: 'telephone',
            key: 'telephone',
            width: 100,
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 160,
        }];

        if (roleAuth && isConfig && !isCompleted) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                fixed: 'right',
                width: 80,
                render: (text, record) => {
                    const { investigationSiteId, reference } = record;
                    const operationCorrespondRoles = new Map([
                        ['edit', {
                            name: '修改',
                            display: !reference,
                            editable: true,
                            event: () => update(record, 'edit'),
                            roles: ['*'],
                        }],
                        ['delete', {
                            name: '删除',
                            display: true,
                            editable: true,
                            event: () => omit(investigationSiteId),
                            roles: ['*'],
                        }],
                        ['relate', {
                            name: '合同关联',
                            display: true,
                            editable: true,
                            event: () => relate(record),
                            roles: ['*'],
                        }],
                    ]);
                    return genOperationAuth(operationCorrespondRoles, curRole);
                },
            });
        }
        return columns;
    }

    getDataSource = () => (this.props.data || []).map(item => {
        const { chargePerson } = item;

        return {
            ...item,
            ...(chargePerson || {}),
            hospitalMainId: item.hospitalMainId,
        };
    })

    render() {
        const { loading, pagination, sortParams, onChange } = this.props;
        return (
            <TableC
                loading={loading}
                pagination={pagination}
                sortParams={sortParams}
                columns={this.getColumns()}
                data={this.getDataSource()}
                onChange={onChange}
                rowKey="investigationSiteId"
                className="researchCenterDetail"
            />
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/List.js